import React from 'react'
import { Button } from '@/components/ui/button'
import { Settings, History } from 'lucide-react'
import RoadmapTabs from '@/components/dashboard/roadmap/RoadmapTabs'
import { createPortal } from 'react-dom'
import { cn } from '@/lib/utils'

export default function Topbar({
  className,
  onToggleHistory,
  showRoadmapNav,
  onOpenConfigDialog,
}: {
  className?: string
  onToggleHistory?: () => void
  showRoadmapNav?: boolean
  onOpenConfigDialog?: () => void
}) {
  return (
    <div
      className={cn(
        'h-[70px] w-full bg-white dark:bg-gray-900 z-50 border-b-2 border-grey-200 dark:border-gray-700 flex',
        className
      )}
    >
      {showRoadmapNav && (
        <div className="flex-1 flex items-center px-6">
          <h1 className="text-[28px] font-bold font-dm-sans dark:text-white">Suggestions</h1>
          <div className="flex-1 flex justify-center">
            <RoadmapTabs />
          </div>
          <div className="flex items-center gap-2">
            {/* TODO: History button temporarily disabled - uncomment to restore history functionality */}
            {/* 
            <Button
              onClick={onToggleHistory}
              variant="ghost"
              size="icon"
              className="text-gray-500 hover:text-gray-900 dark:text-gray-400 dark:hover:text-gray-100"
            >
              <History className="h-5 w-5" />
            </Button>
            */}
            <Button
              onClick={() => {
                console.log('onOpenConfigDialog')
                onOpenConfigDialog()
              }}
              variant="outline"
              className="flex items-center gap-2 border-[#FF4A8E] text-[#FF4A8E] hover:bg-[#FFEFF5] hover:text-[#FF4A8E] dark:bg-gray-800 dark:hover:bg-gray-700"
            >
              <Settings className="h-4 w-4" />
              Configure
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
